import { giphyBlack } from '@giphy/js-brand'
import { ReactNode } from 'react'
import { ControlSize } from 'types'
import { IconButtonProps } from '../../icon-button'
import { Button, Header, Label, LabelText } from './style'

type Props = {
    buttonOptions?: Partial<IconButtonProps>
    className?: string
    controlColor: string
    isOpen?: boolean
    label?: ReactNode
    size?: ControlSize
    onToggle?: (open: boolean) => void
}

const CollapseHeader = ({ buttonOptions, className, controlColor, isOpen = false, label, size, onToggle }: Props) => {
    return (
        <Header className={className} controlColor={controlColor}>
            <Label>{typeof label === 'string' ? <LabelText>{label}</LabelText> : label}</Label>
            <Button
                color={giphyBlack}
                iconScale={0.9}
                {...buttonOptions}
                icon="navigate-down"
                isOpen={isOpen}
                size={size}
                onClick={() => onToggle?.(!isOpen)}
            />
        </Header>
    )
}

export default CollapseHeader
